var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPage',[_c('template',{slot:"Title"},[_vm._v(" This looks empty ")]),_c('template',{slot:"SubTitle"}),_c('template',{slot:"Content"},[_vm._v(" Search your library to add tracks here ")]),_c('template',{slot:"Actions"},[_c('button',[_vm._v("Quick search tracks")]),_c('button',[_vm._v("Upload tracks")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }